import React from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../../CustomPagination';
import Link from '../../../Link';
import Loader from '../../../../components/Common/Loader';

import messages from '../../../../locale/messages';
import history from '../../../../history';
import debounce from '../../../../helpers/debounce';
import { updatePricingStatus } from '../../../../actions/siteadmin/Pricing/updatePricingStatus';
import { deletePricing } from '../../../../actions/siteadmin/Pricing/deletePricing';
import getCurrentPage from '../../../../helpers/getCurrentPage';
import { demoRestriction } from '../../../../actions/demoRestriction';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../../components/commonStyle.css';
import s from './PricingList.css';
class PricingList extends React.Component {
  static defaultProps = {
    pricingDetails: {
      loading: true
    }
  };
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchKeyword: ''
    };
  }

  handleClick = () => {
    history.push('/add')
  }

  handleKeywordSearch = debounce((searchKeyword) => {
    const { pricingDetails: { refetch } } = this.props
    let variables = {
      currentPage: 1,
      searchKeyword
    }
    this.setState({ searchKeyword, currentPage: 1 });
    refetch(variables);
  });

  handleDelete = async (id, currentPage) => {
    const { deletePricing, pricingDetails: { refetch, getAllPricing }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({ restrictType: 'fare', restrictValue: id });
    if (isRestrict) return;
    currentPage = await getCurrentPage({ results: getAllPricing?.results, page: currentPage });
    let variables = { currentPage };
    const response = await deletePricing(id);
    if (response?.status == 200) {
      this.setState({ currentPage });
      refetch(variables);
    }
  }

  paginationData = (currentPage) => {
    const { pricingDetails: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleStatus = async (e, id) => {
    const { updatePricingStatus, pricingDetails: { refetch }, demoRestriction } = this.props;
    let status = e.target.value == 'true' ? true : false;
    const isRestrict = await demoRestriction({ restrictType: 'fare', restrictValue: id });
    if (isRestrict) return;
    const updateActiveStatus = await updatePricingStatus(id, status);
    if (updateActiveStatus && updateActiveStatus.status === 200) {
      let variables = { currentPage: 1 };
      this.setState({ currentPage: 1 });
      refetch(variables);
    }
  }

  render() {
    const { pricingDetails, pricingDetails: { loading, getAllPricing }, loadingTable } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;
    return (
      <div className={'whiteDropdown'}>
        <div className={s.exportDisplay}>
          <div className={s.searchGroupContainer}>
            <div className={cx(s.searchInput, 'searchInputRTL')}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
            </div>
          </div>
          <div className={cx(s.exportTextSection)}>
            <Link to={"/siteadmin/pricing/add"} className={cx(bt.btnPrimary, bt.displayInlineBlock)} >{formatMessage(messages.addFare)}</Link>
          </div>
        </div>
        {
          loadingTable && <div>
            <Loader type="circle" />
          </div>
        }
        {!loadingTable &&
          <div className='tableOuterContainer'>
            <Table className="tableContainer">
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.id} /></th>
                  <th scope="col"><FormattedMessage {...messages.locationName} /></th>
                  <th scope="col"><FormattedMessage {...messages.category} /></th>
                  <th scope="col"><FormattedMessage {...messages.subCategory} /></th>
                  <th scope="col"><FormattedMessage {...messages.status} /></th>
                  <th scope="col"><FormattedMessage {...messages.action} /></th>
                  <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  pricingDetails?.getAllPricing?.results
                  && pricingDetails?.getAllPricing?.count > 0 && pricingDetails?.getAllPricing?.results?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.id)}>{item.id}</td>
                        <td data-label={formatMessage(messages.locationName)}>{item.location && item.location.locationName}</td>
                        <td data-label={formatMessage(messages.category)}>{item.category && item.category.name}</td>
                        <td data-label={formatMessage(messages.subCategory)}>{item.subCategory && item.subCategory.name}</td>
                        <td data-label={formatMessage(messages.status)}>
                          <div>
                            <select value={item.isActive} onChange={(e) => { this.handleStatus(e, item.id) }} className={bt.selectInput}>
                              <option value={true}>{formatMessage(messages.active)}</option>
                              <option value={false}>{formatMessage(messages.inactive)}</option>
                            </select>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.action)}>
                          <div>
                            <Link to={'/siteadmin/pricing/edit/' + item.id} className={s.noLink}>
                              <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.editAction} />
                              </span>
                            </Link>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.deleteAction)} >
                          <div>
                            <Button onClick={() => this.handleDelete(item.id, currentPage)} className={s.iconBtn}>
                              <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.deleteAction} />
                              </span>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                }
                {
                  !loading && pricingDetails?.getAllPricing && pricingDetails?.getAllPricing?.count == 0 && (
                    <tr>
                      <td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </div>
        }
        {
          pricingDetails?.getAllPricing?.results && pricingDetails?.getAllPricing?.count > 0
          && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={pricingDetails?.getAllPricing?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.fares)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapDispatch = {
  updatePricingStatus,
  deletePricing,
  demoRestriction
};

const mapState = (state) => ({
  loading: state?.intl?.loading
});

export default injectIntl(compose(
  withStyles(bt, s),
  connect(mapState, mapDispatch)
)(PricingList));
